module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+aWNvbi10cmFzaDwvdGl0bGU+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMiAyaDIwdjIwSDJ6Ii8+PHBhdGggZD0iTTkgNUg0djJoMTZWNWgtNWMwLS41NTYtLjQ0NC0xLS45OS0xSDkuOTlBMSAxIDAgMCAwIDkgNXpNNSA3aDE0djEyLjAwMWMwIC41NTItLjQ1Ljk5OS0xLjAwNy45OTlINi4wMDdBMS4wMDMgMS4wMDMgMCAwIDEgNSAxOS4wMDFWN3ptMiAwdjExaDEwVjdIN3ptMiAyaDJ2N0g5Vjl6bTQgMGgydjdoLTJWOXoiIGZpbGw9IiM0ODQ4NDgiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctype/icon-del.svg
// module id = NpVA
// module chunks = 25